import { frontLabel } from "../Helpers/labels";

export function quickSearchOptions(labelsName) {
  return [
    {
      label: frontLabel(labelsName, "lbl_ten_latest"),
      value: "10",
      type: "latest",
    },
    {
      label: frontLabel(labelsName, "lbl_storage"),
      value: "Storage",
      type: "room",
    },
    {
      label: frontLabel(labelsName, "lbl_single_room"),
      value: "Single Room",
      type: "room",
    },
    {
      label: frontLabel(labelsName, "lbl_studio"),
      value: "Studio",
      type: "room",
    },
    { label: `2 ${frontLabel(labelsName, "lbl_rooms")}`, value: "2", type: "room" },
    { label: `3 ${frontLabel(labelsName, "lbl_rooms")}`, value: "3", type: "room" },
    { label: `4 ${frontLabel(labelsName, "lbl_rooms")}`, value: "4", type: "room" },
    { label: `5+ ${frontLabel(labelsName, "lbl_rooms")}`, value: "5+", type: "room" },
    {
      label: frontLabel(labelsName, "lbl_detached_house"),
      value: "detachedHouse",
      type: "property-type"
    },
    {
      label: frontLabel(labelsName, "lbl_townhouse_twin"),
      value: "townhouseTwin",
      type: "property-type"
    },
    {
      label: frontLabel(labelsName, "lbl_hotel_guest_house"),
      value: "hotelGesthouse",
      type: "property-type"
    },
    {
      label: frontLabel(labelsName, "lbl_garage"),
      value: "garage",
      type: "property-type"
    },
    {
      label: frontLabel(labelsName, "lbl_commercial_property"),
      value: "commercialProperty",
      type: "property-type",
      externalLink: "https://trod.is/"
    },
  ];
}

export function roomOptions(labelsName) {
  return [
    {
      label: frontLabel(labelsName, "lbl_storage"),
      value: "Storage",
      type: "room",
    },
    {
      label: frontLabel(labelsName, "lbl_single_room"),
      value: "Single Room",
      type: "room",
    },
    {
      label: frontLabel(labelsName, "lbl_studio"),
      value: "Studio",
      type: "room",
    },
    { label: `2 ${frontLabel(labelsName, "lbl_rooms")}`, value: "2", type: "room" },
    { label: `3 ${frontLabel(labelsName, "lbl_rooms")}`, value: "3", type: "room" },
    { label: `4 ${frontLabel(labelsName, "lbl_rooms")}`, value: "4", type: "room" },
    { label: `5+ ${frontLabel(labelsName, "lbl_rooms")}`, value: "5+", type: "room" },
  ];
}
